/* =============================================
   STICKY CART BAR — sticky-cart.js
   Layout-4 PDPs · Mobile only · EN + AR
   v4.3 — fixed availability state logic

   Availability rules (single source of truth):
   !available + policy == continue    → preorder
   !available + policy == deny        → outofstock
   available  + untracked             → instock
   available  + qty > 0               → instock
   available  + qty === 0 + continue  → preorder
   available  + qty === 0 + deny      → outofstock  ← was wrongly 'preorder'
   ============================================= */

(function () {
  'use strict';

  var bar = document.getElementById('sticky-cart-bar');
  if (!bar) return;

  var sectionId = bar.dataset.sectionId;
  var SCOPE = '#ProductSection-' + sectionId;
  var BTN_SEL = '.pf-btn-cart[data-add-to-cart]';
  var QTY_SEL = '.pf-qty-input[data-quantity-input]';
  var PRICE_SEL = '[data-total-price][data-price-value]';
  var PREORDER_SEL = '.pre-oder-custom';

  var stockLabel = document.getElementById('scb-stock-label');
  var priceEl = document.getElementById('scb-price-value');
  var qtyEl = document.getElementById('scb-qty-value');
  var minusBtn = document.getElementById('scb-minus');
  var plusBtn = document.getElementById('scb-plus');
  var actionBtn = document.getElementById('scb-action-btn');
  var btnText = document.getElementById('scb-btn-text');

  var labels = {
    stock: {
      instock: stockLabel.dataset.labelInstock,
      preorder: stockLabel.dataset.labelPreorder,
      outofstock: stockLabel.dataset.labelOutofstock
    },
    btn: {
      instock: actionBtn.dataset.labelInstock,
      preorder: actionBtn.dataset.labelPreorder,
      outofstock: actionBtn.dataset.labelOutofstock
    }
  };

  var qty = 1;
  var unitCents = parseInt(bar.dataset.priceCents, 10) || 0;
  var productCache = null;
  var mobileMq = window.matchMedia('(max-width: 768px)');
  var visibilityObserver = null;
  var scrollFallbackBound = false;

  function isMobileStickyCart() {
    return mobileMq.matches;
  }

  function getWhatsAppRootButtons() {
    var all = Array.prototype.slice.call(document.querySelectorAll('#whas-ap-fl-b, .whas-ap-fl-b'));
    return all.filter(function (el) {
      return !all.some(function (other) {
        return other !== el && other.contains(el);
      });
    });
  }

  function clearWhatsAppScbState() {
    document.querySelectorAll('#whas-ap-fl-b, .whas-ap-fl-b').forEach(function (el) {
      el.removeAttribute('data-scb-wa-primary');
      el.removeAttribute('data-scb-wa-duplicate');
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
      el.style.removeProperty('bottom');
      el.style.removeProperty('transform');
    });
  }

  function sizeWhatsAppImages(root) {
    if (!root) return;
    root.querySelectorAll('img').forEach(function (img) {
      if (img.dataset.scbSized === '1') return;
      img.dataset.scbSized = '1';
      img.setAttribute('width', '48');
      img.setAttribute('height', '48');
      img.style.setProperty('width', '48px', 'important');
      img.style.setProperty('height', '48px', 'important');
      img.style.setProperty('max-width', '48px', 'important');
      img.style.setProperty('aspect-ratio', '1 / 1', 'important');
      img.style.setProperty('object-fit', 'contain', 'important');
    });
  }

  function syncWhatsAppPosition() {
    if (!isMobileStickyCart()) {
      clearWhatsAppScbState();
      return;
    }

    var roots = getWhatsAppRootButtons();
    if (!roots.length) {
      return;
    }

    roots.sort(function (a, b) {
      return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });

    var primary = roots[0];

    roots.forEach(function (el) {
      sizeWhatsAppImages(el);

      if (el !== primary) {
        el.setAttribute('data-scb-wa-duplicate', '1');
        el.removeAttribute('data-scb-wa-primary');
        return;
      }

      el.removeAttribute('data-scb-wa-duplicate');
      el.setAttribute('data-scb-wa-primary', '1');
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
      /* Bottom offset is CSS-only (body.scb-bar-active) — avoid inline bottom toggles (CLS). */
      el.style.removeProperty('bottom');
      el.style.removeProperty('transform');
    });
  }

  function initWhatsAppObserver() {
    if (!window.MutationObserver || document.body.dataset.scbWhatsAppObs === '1') {
      return;
    }
    document.body.dataset.scbWhatsAppObs = '1';
    var waTimer = null;
    var observer = new MutationObserver(function () {
      if (!isMobileStickyCart()) return;
      if (waTimer) clearTimeout(waTimer);
      waTimer = setTimeout(syncWhatsAppPosition, 200);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function scopedQ(sel) {
    var scope = document.querySelector(SCOPE) || document;
    return scope.querySelector(sel);
  }

  function getProductData() {
    if (productCache) return productCache;
    var el = document.getElementById('ProductJson-' + sectionId);
    if (!el || !el.textContent.trim()) return null;
    try {
      productCache = JSON.parse(el.textContent.trim());
    } catch (e) {
      productCache = null;
    }
    return productCache;
  }

  function getVariantById(id) {
    if (!id) return null;
    var product = getProductData();
    if (!product || !product.variants) return null;
    var sid = String(id);
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === sid) return product.variants[i];
    }
    return null;
  }

  function getVariantId() {
    var input = scopedQ('input[name="id"]');
    if (input && input.value) return input.value;
    var master = scopedQ('select#ProductSelect-' + sectionId);
    if (master && master.value) return master.value;
    try {
      var v = new URLSearchParams(window.location.search).get('variant');
      if (v) return v;
    } catch (e) { /* ignore */ }
    return null;
  }

  function setPriceFromCents(cents) {
    unitCents = cents;
    priceEl.setAttribute('data-price-value', cents);
    bar.dataset.priceCents = cents;
    renderPrice();
  }

  function renderPrice() {
    priceEl.textContent = (unitCents * qty / 100).toFixed(2);
  }

  function syncPriceFromDOM() {
    var src = scopedQ(PRICE_SEL);
    if (src) {
      var c = parseInt(src.getAttribute('data-price-value'), 10);
      if (!isNaN(c)) {
        setPriceFromCents(c);
        return;
      }
    }
    var fallback = parseInt(bar.dataset.priceCents, 10);
    if (!isNaN(fallback)) setPriceFromCents(fallback);
  }

  /* Same qty source as theme.js _updateAddToCart */
  function getInventoryQty(variant) {
    if (!variant) return null;
    var id = String(variant.id);
    var arr = window.inven_array || {};
    if (Object.prototype.hasOwnProperty.call(arr, id)) {
      var n = parseInt(arr[id], 10);
      return isNaN(n) ? null : n;
    }
    if (variant.inventory_management == null) return null;
    if (variant.inventory_quantity != null && !isNaN(variant.inventory_quantity)) {
      return parseInt(variant.inventory_quantity, 10);
    }
    return null;
  }

  /* Merge event variant (fresh available) with ProductJson (policy, qty) */
  function resolveVariant(variant) {
    if (!variant) return getVariantById(getVariantId());
    var fromJson = getVariantById(variant.id);
    if (!fromJson) return variant;
    var merged = {};
    var k;
    for (k in fromJson) {
      if (Object.prototype.hasOwnProperty.call(fromJson, k)) merged[k] = fromJson[k];
    }
    for (k in variant) {
      if (Object.prototype.hasOwnProperty.call(variant, k)) merged[k] = variant[k];
    }
    return merged;
  }

  /* ─── FIX 1: correct availability rules ─────────────────────────────────
     Old code returned 'preorder' for ANY variant with qty === 0,
     even when inventory_policy is 'deny' (= sold out, not pre-order).
     Now policy is always checked before deciding preorder vs outofstock.
  ──────────────────────────────────────────────────────────────────────── */
  function detectStateFromVariant(variant) {
    if (!variant) return detectStateFromDOM();

    /* Not available at all */
    if (!variant.available) {
      return (variant.inventory_policy === 'continue') ? 'preorder' : 'outofstock';
    }

    /* Available but untracked — always in stock */
    if (variant.inventory_management === null ||
        variant.inventory_management === undefined) {
      return 'instock';
    }

    var stockQty = getInventoryQty(variant);

    /* Can't determine qty — trust Shopify's available flag */
    if (stockQty === null) return 'instock';

    /* Has positive stock */
    if (stockQty > 0) return 'instock';

    /* qty === 0: pre-order only when policy allows oversell */
    if (stockQty <= 0) {
      return (variant.inventory_policy === 'continue') ? 'preorder' : 'outofstock';
    }

    return 'instock';
  }

  /* ─── FIX 2: DOM fallback no longer checks hidden [data-l4-preorder] ───
     The old fallback looked for a [data-l4-preorder] element that is hidden
     inside .l4-oos-block when the product is in-stock, causing it to miss
     and fall through to 'instock' incorrectly.
     Now we read variant data from ProductJson first, then check the ATC
     button disabled state, then the pre-order label visibility.
  ──────────────────────────────────────────────────────────────────────── */
  function detectStateFromDOM() {
    /* Always prefer real variant data */
    var variant = getVariantById(getVariantId());
    if (variant) return detectStateFromVariant(variant);

    /* ATC button disabled → out of stock */
    var btn = scopedQ(BTN_SEL);
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) {
      return 'outofstock';
    }

    /* Pre-order label visible in main PDP */
    var preLabel = scopedQ(PREORDER_SEL);
    if (preLabel && preLabel.offsetParent !== null) return 'preorder';

    /* inven_array fallback */
    var variantId = getVariantId();
    var invenArr = window.inven_array || {};
    var stock = variantId
      ? (invenArr[variantId] !== undefined ? invenArr[variantId] : invenArr[String(variantId)])
      : undefined;

    if (stock > 0) return 'instock';

    /* qty === 0: check main PDP OOS block visibility to decide */
    if (stock === 0 || stock !== undefined) {
      var oosBlock = document.querySelector('.l4-oos-block');
      var instockBlock = document.querySelector('.l4-instock-block');

      /* If instock block is visible in main PDP, honour it */
      if (instockBlock && instockBlock.offsetParent !== null &&
          getComputedStyle(instockBlock).display !== 'none') {
        return 'instock';
      }
      /* If oos block visible, check for pre-order text inside it */
      if (oosBlock && oosBlock.offsetParent !== null &&
          getComputedStyle(oosBlock).display !== 'none') {
        var preBtn = oosBlock.querySelector('[data-l4-preorder], .pre-oder-custom');
        if (preBtn && preBtn.offsetParent !== null) return 'preorder';
        return 'outofstock';
      }
      return 'outofstock';
    }

    return 'instock';
  }

  function applyState(state) {
    bar.classList.remove('state-instock', 'state-preorder', 'state-outofstock');
    bar.classList.add('state-' + state);
    stockLabel.textContent = labels.stock[state] || labels.stock.instock;
    btnText.textContent = labels.btn[state] || labels.btn.instock;
    actionBtn.disabled = (state === 'outofstock');
  }

  function syncQtyFromPage() {
    var input = scopedQ(QTY_SEL);
    if (input) {
      qty = parseInt(input.value, 10) || 1;
      qtyEl.textContent = qty;
    }
  }

  function syncFromVariant(variant) {
    variant = resolveVariant(variant);
    if (variant) {
      if (variant.price != null) setPriceFromCents(variant.price);
      applyState(detectStateFromVariant(variant));
    } else {
      syncPriceFromDOM();
      applyState(detectStateFromDOM());
    }
    syncQtyFromPage();
  }

  function afterVariantStable(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  function updateQty(newQty) {
    qty = Math.max(1, newQty);
    qtyEl.textContent = qty;
    renderPrice();
    var input = scopedQ(QTY_SEL);
    if (input) {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  minusBtn.addEventListener('click', function () { updateQty(qty - 1); });
  plusBtn.addEventListener('click', function () { updateQty(qty + 1); });

  function bindQtyListener() {
    var input = scopedQ(QTY_SEL);
    if (!input) return;
    input.addEventListener('change', function () {
      qty = parseInt(input.value, 10) || 1;
      qtyEl.textContent = qty;
      renderPrice();
    });
  }

  function bindVariantListener() {
    if (!window.jQuery) return false;

    var $ = window.jQuery;
    var $sec = $(SCOPE);
    if (!$sec.length) return false;

    var slideshowNs = 'variantChange.slideshow-' + sectionId;
    var stickyNs = slideshowNs + '.stickyCart';
    var priceNs = 'variantPriceChange.slideshow-' + sectionId + '.stickyCart';

    function onVariantEvt(evt) {
      var variant = evt.variant
        || (evt.originalEvent && evt.originalEvent.variant)
        || null;
      /* Wait for theme.js _updateAddToCart / layout4 inventory UI */
      afterVariantStable(function () {
        syncFromVariant(variant);
      });
    }

    $sec.off(stickyNs).on(stickyNs, onVariantEvt);

    $sec.off(priceNs).on(priceNs, function (evt) {
      var v = evt.variant || (evt.originalEvent && evt.originalEvent.variant);
      if (v && v.price != null) setPriceFromCents(v.price);
    });

    return true;
  }

  function bindVariantFallbacks() {
    var root = document.querySelector(SCOPE);
    if (!root || root.dataset.stickyCartBound) return;
    root.dataset.stickyCartBound = '1';

    var optionSel =
      '.single-option-selector-' + sectionId + ', #ProductSelect-' + sectionId;

    root.addEventListener('change', function (ev) {
      if (!ev.target || !ev.target.matches || !ev.target.matches(optionSel)) return;
      afterVariantStable(function () {
        syncFromVariant(null);
      });
    });

    function onNav() {
      afterVariantStable(function () {
        syncFromVariant(null);
      });
    }

    window.addEventListener('boostShowroom:nav', onNav);
    window.addEventListener('popstate', onNav);
  }

  function initVariantListenerWithRetry() {
    bindVariantFallbacks();

    if (bindVariantListener()) return;

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (bindVariantListener() || attempts >= 80) {
        clearInterval(interval);
      }
    }, 50);
  }

  function showBar() {
    if (!isMobileStickyCart()) return;
    bar.removeAttribute('hidden');
    bar.classList.add('scb-visible');
    document.body.classList.add('scb-bar-active');
    requestAnimationFrame(function () {
      document.documentElement.style.setProperty(
        '--scb-bar-height', bar.offsetHeight + 'px'
      );
      syncWhatsAppPosition();
    });
  }

  function hideBar() {
    bar.classList.remove('scb-visible');
    document.body.classList.remove('scb-bar-active');
    bar.setAttribute('hidden', '');
    syncWhatsAppPosition();
  }

  function teardownVisibility() {
    if (visibilityObserver) {
      visibilityObserver.disconnect();
      visibilityObserver = null;
    }
    if (scrollFallbackBound) {
      window.removeEventListener('scroll', onScrollFallback);
      scrollFallbackBound = false;
    }
  }

  function onScrollFallback() {
    if (!isMobileStickyCart()) return;
    var btn = scopedQ(BTN_SEL);
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    (r.bottom < 0 || r.top > window.innerHeight) ? showBar() : hideBar();
  }

  function initObserver() {
    var btn = scopedQ(BTN_SEL);
    if (!btn) return;
    visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.isIntersecting ? hideBar() : showBar();
      });
    }, { threshold: 0 });
    visibilityObserver.observe(btn);
  }

  function initScrollFallback() {
    if ('IntersectionObserver' in window) return;
    if (scrollFallbackBound) return;
    window.addEventListener('scroll', onScrollFallback, { passive: true });
    scrollFallbackBound = true;
  }

  function initVisibility() {
    teardownVisibility();
    if (!isMobileStickyCart()) {
      hideBar();
      return;
    }
    initObserver();
    initScrollFallback();
  }

  function onBreakpointChange() {
    initVisibility();
    syncWhatsAppPosition();
  }

  /* ─── FIX 3: pre-order tap now clicks the main ATC button ───────────────
     Old code tried to click [data-l4-preorder] which lives inside
     .l4-oos-block. When the main area showed in-stock, that element was
     hidden and the tap did nothing on mobile.
     Now we always click the real ATC button in the PDP form directly.
  ──────────────────────────────────────────────────────────────────────── */
  actionBtn.addEventListener('click', function () {
    if (actionBtn.disabled) return;
    updateQty(qty);

    /* Always delegate to the main PDP Add-to-Cart / Pre-order button */
    var btn = scopedQ(BTN_SEL);
    if (btn) {
      btn.click();
      return;
    }

    /* Last-resort fallback: any add-to-cart button on the page */
    var fallback = document.querySelector('[data-add-to-cart]');
    if (fallback) fallback.click();
  });

  function syncAll() {
    syncPriceFromDOM();
    syncQtyFromPage();
    applyState(detectStateFromDOM());
  }

  function init() {
    if (bar.dataset.stickyCartInit === '1') return;
    bar.dataset.stickyCartInit = '1';

    syncAll();
    initVisibility();
    initVariantListenerWithRetry();
    bindQtyListener();
    initWhatsAppObserver();
    requestAnimationFrame(syncWhatsAppPosition);

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', onBreakpointChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(onBreakpointChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();